/** Acesso via PIX; renovação manual a cada ciclo. */
export const SUBSCRIPTION_STATUS_PIX_MANUAL = 'pix_manual' as const;

/** Cobrança recorrente em falha (ex. assinatura pausada no gateway). */
export const SUBSCRIPTION_STATUS_PAST_DUE = 'past_due' as const;

/** Pagamento recorrente recusado. */
export const SUBSCRIPTION_STATUS_PAYMENT_FAILED = 'payment_failed' as const;
